// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/EngineerWorkloadSection.js
//
// Purpose:
// Engineer Workload Analysis
//
// Shows:
// - Engineer Name
// - Pending Tickets
//
// Click Engineer
// -> DashboardDataDrawer
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

export default function EngineerWorkloadSection({

  data = [],

  onEngineerClick,

}) {

  function handleClick(row) {

    if (
      !row ||
      !onEngineerClick
    ) {
      return;
    }

    onEngineerClick(
      row.engineer
    );
  }

  return (

    <DashboardCard

      title="Engineer Workload"

      subtitle="Pending tickets assigned to engineers"

      height={450}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <BarChart
          data={data}
          layout="vertical"

          margin={{
            top: 10,
            right: 20,
            left: 30,
            bottom: 10,
          }}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            type="number"
          />

          <YAxis
            type="category"
            dataKey="engineer"
            width={140}
          />

          <Tooltip />

          <Bar
            dataKey="pending_tickets"

            radius={[
              0,
              6,
              6,
              0,
            ]}

            onClick={handleClick}
          >

            {data.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill="#2563eb"
                />

              )
            )}

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}